import axios from "axios";
import { GET_COMPANIES, SET_COMPANIES_LOADING, GET_COMPANIES_FAIL, CLEAR_STATE_COMAPANIES,
    REGISTER_COMPANY_SET_LOADING,REGISTER_COMPANY_SUCCESS, REGISTER_COMPANY_FAIL,
    GET__MY_COMPANY, SET_MY_COMPANY_LOADING, GET_MY_COMPANY_FAIL, CLEAR_STATE_MY_COMAPANY,
    POST_REQUEST_COMPANY, LOADING_REQUEST_COMPANY, REQUEST_COMPANY_FAIL,
    GET_ALL_REQUESTS, SET_ALL_REQUESTS_LOADING, GET_ALL_REQUESTS_FAIL, CLEAR_STATE_ALL_REQUESTS,
    POST_CANACEL_REQUEST, LOADING_CANACEL_REQUEST, CANACEL_REQUEST_FAIL,
    GET_COMPANY_REQUESTS, SET_COMPANY_REQUESTS_LOADING, GET_COMPANY_REQUESTS_FAIL, CLEAR_STATE_COMPANY_REQUESTS,
    POST_ACCEPT_REQUEST, LOADING_ACCEPT_REQUEST, POST_ACCEPT_FAIL,
    POST_REJECT_REQUEST, LOADING_REJECT_REQUEST, REJECT_REQUEST_FAIL } from '../actions/types'
import { refreshUser } from './authActions'
import {CLEAR_EDIT_ERRORS, EDIT_COMPANY_FAIL, EDIT_COMPANY_SUCCESS, SET_EDIT_LOADING} from "./actions";
//pobieranie raportu getReport[numer], pobieranie od kodu do rozwijania getCode[numer]
const token =  localStorage.getItem("token");
const headers =  {
  'Accept': "application/json",
  "Content-Type": "application/json",
  "Authorization":`JWT ${token}`
}
export const clearCopmanies = () => async dispatch =>{
  dispatch({type:CLEAR_STATE_COMAPANIES})
}
export const getCompanies =(params)=>async dispatch => {
    dispatch({type: CLEAR_STATE_COMAPANIES})
    dispatch({ type: SET_COMPANIES_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/company/`,
        params: params,
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      // config.method = "get",
      // config.url = `/api/raport31/`
      // config.params = params
      try {
        const response = await axios(config);
        dispatch({
          type: GET_COMPANIES,
          payload: response.data
        });
    
      }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
          type: GET_COMPANIES_FAIL,
        });
      }
    }
//post new company
export const registerCompany = (formData) => async (dispatch) => {
    dispatch({
        type: REGISTER_COMPANY_SET_LOADING,
    });
    
    const config = {
        method: 'post',
        url: `/api/company/`,
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);
    
        dispatch({
        type: REGISTER_COMPANY_SUCCESS,
        payload: response.data
        });
    
        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        // dispatch({
        //   type: GET_ERRORS,
        //   payload: errors
        // })
    
        dispatch({
        type: REGISTER_COMPANY_FAIL,
        payload: errors.msg
        });
    }
    };


//my company
export const getMyCompany =(params)=>async dispatch => {
    dispatch({type: CLEAR_STATE_MY_COMAPANY})
    dispatch({ type: SET_MY_COMPANY_LOADING })
    const config = {
        headers: headers,
        method: "get",
        url: `/api/company/my/`,
        params: params,
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
        const response = await axios(config);
        dispatch({
          type: GET__MY_COMPANY,
          payload: response.data
        });
    
      }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
          type: GET_MY_COMPANY_FAIL,
        });
      }
    }

export const editCompany = (formData,ID) => async (dispatch) => {
    dispatch({
        type: SET_EDIT_LOADING,
    });

    const config = {
        method: 'put',
        url: `/api/company/`+ID+"/",
        data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
        const response = await axios(config);

        dispatch({
        type: EDIT_COMPANY_SUCCESS,
        payload: response.data
        });

        // dispatch(
        //   loadUser()
        // )
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        // dispatch({
        //   type: GET_ERRORS,
        //   payload: errors
        // })

        dispatch({
        type: EDIT_COMPANY_FAIL,
        payload: errors.msg
        });
    }
    };

export const clearEditErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_EDIT_ERRORS,
    });

    };

//request company

export const sendRequest = (formData) => async (dispatch) => {
  dispatch({
      type: LOADING_REQUEST_COMPANY,
  });
  
  const config = {
      method: 'post',
      url: `/api/company_add_request/`,
      data: formData,
      headers: {
      'Content-Type': 'application/json',
      },
  };
  config.headers.Authorization = "JWT " + localStorage.getItem("token");

  try {
      const response = await axios(config);
  
      dispatch({
      type: POST_REQUEST_COMPANY,
      payload: response.data
      });
  } catch (err) {
      const errors = {
      msg: err.response.data,
      status: err.response.status,
      };
      dispatch({
      type: REQUEST_COMPANY_FAIL,
      payload: errors.msg
      });
  }
  };
  //get all requests
  export const getAllRequest=(params)=>async dispatch => {
    dispatch({type: CLEAR_STATE_ALL_REQUESTS})
    dispatch({ type: SET_ALL_REQUESTS_LOADING })
    params['ordering'] = '-id'
    const config = {
        headers: headers,
        method: "get",
        url: `/api/company_add_request/`,
        params: params,
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
        const response = await axios(config);
        dispatch({
          type: GET_ALL_REQUESTS,
          payload: response.data
        });
    
      }catch (err) {
        console.log("error: ", JSON.stringify(err))
        refreshUser()
        dispatch({
          type: GET_ALL_REQUESTS_FAIL,
        });
      }
    }
  //CANCEL request
  export const cancelRequest = (id) => async (dispatch) => {
    dispatch({
        type: LOADING_CANACEL_REQUEST,
    });
    const config = {
        method: 'post',
        url: `/api/company_add_request/${id}/cancel/`,
        // data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
        const response = await axios(config);
    
        dispatch({
        type: POST_CANACEL_REQUEST,
        payload: response.data
        });
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: CANACEL_REQUEST_FAIL,
        payload: errors.msg
        });
    }
    };
    //GET REQEST FOR ADMIN
    export const getCompanyRequest=(params)=>async dispatch => {
      dispatch({type: CLEAR_STATE_COMPANY_REQUESTS})
      dispatch({ type: SET_COMPANY_REQUESTS_LOADING })
      params['ordering'] = '-id'
      const config = {
          headers: headers,
          method: "get",
          url: `/api/company_add_request/company_view/`,
          params: params,
        };
        config.headers.Authorization = "JWT " + localStorage.getItem("token");
        try {
          const response = await axios(config);
          dispatch({
            type: GET_COMPANY_REQUESTS,
            payload: response.data
          });
      
        }catch (err) {
          console.log("error: ", JSON.stringify(err))
          refreshUser()
          dispatch({
            type: GET_COMPANY_REQUESTS_FAIL,
          });
        }
      }
  //ACCEPT REQ
  export const acceptRequest = (id) => async (dispatch) => {
    dispatch({
        type: LOADING_ACCEPT_REQUEST,
    });
    const config = {
        method: 'post',
        url: `/api/company_add_request/${id}/accept/`,
        // data: formData,
        headers: {
        'Content-Type': 'application/json',
        },
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
        const response = await axios(config);
    
        dispatch({
        type: POST_ACCEPT_REQUEST,
        payload: response.data
        });
    } catch (err) {
        const errors = {
        msg: err.response.data,
        status: err.response.status,
        };
        dispatch({
        type: POST_ACCEPT_FAIL,
        payload: errors.msg
        });
    }
    };
    ///reject request
    export const rejectRequest = (id) => async (dispatch) => {
      dispatch({
          type: LOADING_REJECT_REQUEST,
      });
      const config = {
          method: 'post',
          url: `/api/company_add_request/${id}/reject/`,
          // data: formData,
          headers: {
          'Content-Type': 'application/json',
          },
      };
      config.headers.Authorization = "JWT " + localStorage.getItem("token");
      try {
          const response = await axios(config);
      
          dispatch({
            type: POST_REJECT_REQUEST,
            payload: response.data
          });
      } catch (err) {
        console.log("error: ", JSON.stringify(err))
        dispatch({
          type: REJECT_REQUEST_FAIL,
          payload: JSON.stringify(err)
        });
      }
      };
